// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Page_mainContainer__4WRkk"};